export default class Elemento {
  constructor() {
    this.cod = new String();
    this.literales = new Array();
    this.getLiteral = function (param) {
      var filter = this.literales.filter(
        (literalEl) => literalEl.codIdioma == param
      );

      return filter.length == 1
        ? filter[0].texto
        : (literal = '[' + this.cod + ']');
    };
  }
}
